import { BaseModel } from "sjs-base-model";
import { GROUP_LEGAL } from "../../../constants/general";

const NAME = "name";
const IMAGE = "image";
const LINK = "link";
const CLIENT_ID = "clientId";
const IS_LEGAL = "isLegal"; //local
const STATIC = "static"; //url estática, no hay que concatenar nada
const PROVISIONAL_ACCESS_DAYS = "provisionalAccessDays"; //días de acceso provisional mientras los responsables aceptan la solicitud¡
const RESPONSIBLES = "managers"; //array de logins de responsables de la aplicación
const CHECK_RESPONSIVE_ACTIVE = "checkResponsiveActive";
const GROUP = "group";

export const APP_PROPERTIES = {
  CLIENT_ID: CLIENT_ID,
  NAME: NAME,
  IMAGE: IMAGE,
  PROVISIONAL_ACCESS_DAYS: PROVISIONAL_ACCESS_DAYS,
  RESPONSIBLES: RESPONSIBLES,
  CHECK_RESPONSIVE_ACTIVE: CHECK_RESPONSIVE_ACTIVE,
  GROUP: GROUP,
};

export default class AppModel extends BaseModel {
  [NAME] = null;
  [IMAGE] = null;
  [LINK] = null;
  [CLIENT_ID] = null;
  [IS_LEGAL] = false;
  [STATIC] = false;
  [CHECK_RESPONSIVE_ACTIVE] = false;
  [PROVISIONAL_ACCESS_DAYS] = 0;
  [RESPONSIBLES] = [];
  [GROUP] = null;

  constructor(data) {
    super();
    this.update(data);
  }

  getName = () => this[NAME];
  getResponsibles = () => this[RESPONSIBLES];
  getClientId = () => this[CLIENT_ID];
  getFilterName = (t) => (this.isLegalGroup() ? `${t("appLegal")} ${this[NAME]}` : this[NAME]);
  getImage = () => this[IMAGE];
  getLink = () => this[LINK];
  isCDT = () => this[NAME] === "CDT";
  getIsLegal = () => this[IS_LEGAL];
  isStatic = () => this[STATIC];
  isLegalGroup = () => this[GROUP] === GROUP_LEGAL;
  getModelProperty = (p) => this[p];
  setModelProperty = (property, value) => (this[property] = value);

  isDifferent = (otherItem) => {
    const different = [PROVISIONAL_ACCESS_DAYS].find((p) => otherItem[p] !== this[p]);

    let responsiblesDifferent =
      otherItem[RESPONSIBLES].find((o) => !this[RESPONSIBLES].find((c) => c === o)) ||
      this[RESPONSIBLES].find((o) => !otherItem[RESPONSIBLES].find((c) => c === o));

    return different || responsiblesDifferent ? true : false;
  };

  getSaveFields = () => {
    let resp = {
      [RESPONSIBLES]: this[RESPONSIBLES],
      [PROVISIONAL_ACCESS_DAYS]: this[PROVISIONAL_ACCESS_DAYS],
      [CHECK_RESPONSIVE_ACTIVE]: this[CHECK_RESPONSIVE_ACTIVE],
    };
    return resp;
  };
}
